import { initializeApollo } from "utils/with-apollo.utils";

import {
  ComingSoonCatalogDocument,
  ComingSoonCatalogQuery,
} from "./coming-soon-catalog.query.generated";

export const getComingSoonEntries = async () => {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query<ComingSoonCatalogQuery>({
    query: ComingSoonCatalogDocument,
  });

  return data?.comingSoonCatalog?.data?.attributes?.entries?.map((entry) => {
    const flagshipVariant =
      entry?.flagship?.data?.attributes?.smartphoneVariant?.data?.attributes;
    const flagshipPicture = flagshipVariant?.combinedPicture?.data?.attributes;
    const flagshipPictureText = flagshipPicture?.alternativeText;
    const flagshipPictureFormats = flagshipPicture?.formats;

    const picture = {
      alternativeText: flagshipPictureText ?? null,
      medium: flagshipPictureFormats?.medium?.url ?? null,
      thumbnail: flagshipPictureFormats?.thumbnail?.url ?? null,
    };

    const brand = flagshipVariant?.smartphoneFamily?.data?.attributes?.brand

    const tagSlugs = entry?.tags?.data?.map(
      ({ attributes }) => attributes?.slug,
    );

    const slug = `/${flagshipVariant?.smartphoneFamily?.data?.attributes?.slug}`;

    return {
      entryName: entry?.entryName ?? "",
      brand: brand ?? "",
      releaseDate: entry?.releaseDate ?? "",
      picture,
      slug,
      tagSlugs
    };
  });
};
